import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../../services/AuthService';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-location-switcher',
  template: `
    @if (auth.currentLocations().length > 1) {
      <div class="hidden sm:block">
        <p-select
          [options]="locations()"
          [ngModel]="auth.currentLocationId()"
          (ngModelChange)="onLocationChange($event)"
          class="hidden sm:block"
          style="min-width: 200px"
          optionLabel="name"
          optionValue="id"
          placeholder="{{ 'Select Location' | transloco }}"
          size="small"/>
      </div>
    }
  `,
  imports: [
    Select,
    FormsModule,
    TranslocoPipe
  ]
})
export class LocationSwitcher {
  private t = inject(TranslocoService);
  public auth = inject(AuthService);

  public locations = computed(() => {
    return this.auth.currentLocations().map(l => ({
      ...l,
      name: l.name === "All" ? this.t.translate("All") : l.name
    }));
  });

  protected onLocationChange(locationId: number) {
    this.auth.currentLocationId.set(locationId);
    this.auth.changeLocation(locationId);
  }
}
